export default __webpack_public_path__ + "static/media/tap_here_top_ios_18.5e849e3d.png";